var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pagina-usuario" }, [
    _c(
      "div",
      { staticClass: "btn-voltar", on: { click: _vm.goToGestaoUsuario } },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/icons/arrow_back_ios.svg"),
            alt: "Botão voltar"
          }
        }),
        _c("span", [_vm._v(" Voltar para gestão de usuários")])
      ]
    ),
    _vm.userTeste
      ? _c(
          "div",
          { staticClass: "infos-usuario" },
          [
            _c(
              "v-card",
              { staticClass: "perfil-usuario" },
              [
                _c("div", { staticClass: "section-user profile" }, [
                  _c("figure", { staticClass: "img" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/empty" + this.id + ".png"),
                        alt: ""
                      }
                    })
                  ]),
                  _c("div", { staticClass: "nome-usuario" }, [
                    _c("div", { staticClass: "title" }, [
                      _c("span", [_vm._v("Nome")])
                    ]),
                    _c("div", { staticClass: "nome" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.userTeste.name || "Eleanor pena"))
                      ])
                    ])
                  ])
                ]),
                _c("div", { staticClass: "section-user email center" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("Email")])
                  ]),
                  _c("div", { staticClass: "email" }, [
                    _c("span", { staticClass: "light" }, [
                      _vm._v(_vm._s(_vm.userTeste.email))
                    ])
                  ])
                ]),
                _c("div", { staticClass: "section-user telefone center" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("Telefone")])
                  ]),
                  _c("div", { staticClass: "telefone" }, [
                    _c("span", { staticClass: "light" }, [
                      _vm._v(
                        _vm._s(_vm.userTeste.phoneNumber || "(84) 92508-9833")
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "section-user dataCadastro center" }, [
                  _c("div", { staticClass: "title" }, [
                    _c("span", [_vm._v("Data de cadastro")])
                  ]),
                  _c("div", { staticClass: "data-cadastro" }, [
                    _c("span", { staticClass: "light" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatDate(_vm.userTeste.created_at) ||
                            "22/09/2021"
                        )
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "section-user btns" }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn-editar",
                      on: {
                        click: function($event) {
                          return _vm.showModal("editarUsuario", $event)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/icons/edit_icon.svg"),
                          alt: "Botão de editar"
                        }
                      })
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "btn-deletar",
                      on: { click: _vm.deletItem }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/icons/delete_outline_icon.svg"),
                          alt: "Botão de deletar"
                        }
                      })
                    ]
                  )
                ]),
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.dialogDelete,
                      callback: function($$v) {
                        _vm.dialogDelete = $$v
                      },
                      expression: "dialogDelete"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      { staticClass: "card-dialog" },
                      [
                        _c("v-card-title", { staticClass: "text-h5" }, [
                          _c("span", [_vm._v("Deletar usuário?")])
                        ]),
                        _c("v-card-text", { staticClass: "descricao-dialog" }, [
                          _vm._v(
                            " Isso irá apagar permanentemente todas as informações e transações anteriormente cadastradas "
                          )
                        ]),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-cancel-dialog",
                                attrs: { color: "blue darken-1", text: "" },
                                on: { click: _vm.closeDelete }
                              },
                              [_c("span", [_vm._v("Cancelar")])]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "btn-delete-dialog",
                                attrs: {
                                  color: "blue darken-1",
                                  text: "",
                                  loading: _vm.loading
                                },
                                on: { click: _vm.deleteUsuario }
                              },
                              [_c("span", [_vm._v("Deletar")])]
                            ),
                            _c("v-spacer")
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "btn-close-dialog",
                            on: { click: _vm.closeDialog }
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                src: require("@/assets/icons/clear_icon.svg")
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._m(0),
            _c("div", { staticClass: "infos" }, [
              _c("div", { staticClass: "bloco1" }, [
                _vm._m(1),
                _vm.arrTeste && _vm.arrTeste2
                  ? _c(
                      "div",
                      { staticClass: "grafico" },
                      [
                        _c("LineChart", {
                          attrs: {
                            chartData: _vm.arrTeste,
                            chartData2: _vm.arrTeste2,
                            options: _vm.chartOptions,
                            label: "Grafico mocado"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._m(2)
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cards" }, [
      _c("div", { staticClass: "card" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Saldo Bruto")]),
        _c("span", { staticClass: "valor" }, [_vm._v("R$ 1.369.771,86")])
      ]),
      _c("div", { staticClass: "card" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Saldo Liquido")]),
        _c("span", { staticClass: "valor" }, [_vm._v("R$ 1.369.771,86")])
      ]),
      _c("div", { staticClass: "card" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Rendimento")]),
        _c("span", { staticClass: "valor" }, [_vm._v("R$ 1.369.771,86")])
      ]),
      _c("div", { staticClass: "card" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Rendimento Histórico")]),
        _c("span", { staticClass: "valor" }, [_vm._v("12,63%")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-bloco" }, [
      _c("span", [_vm._v("Título do gráfico")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bloco2" }, [
      _c("div", { staticClass: "title-bloco" }, [
        _c("span", [_vm._v("Transações recentes")])
      ]),
      _c("ul", { staticClass: "lista" }, [
        _c("li", [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Compra - novo ativo")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", { staticClass: "teste" }, [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Venda - ativo existente")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Compra - novo ativo")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Compra - novo ativo")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Compra - novo ativo")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", { staticClass: "teste" }, [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Venda - ativo existente")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", { staticClass: "teste" }, [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Venda - ativo existente")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Compra - novo ativo")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ]),
        _c("li", [
          _c("div", { staticClass: "textos" }, [
            _c("div", { staticClass: "title-item" }, [
              _c("span", [_vm._v("Compra - novo ativo")])
            ]),
            _c("div", { staticClass: "sub-title-item" }, [
              _c("span", [_vm._v("Fundo Imobiliário")])
            ]),
            _c("div", { staticClass: "data-item" }, [
              _c("span", [_vm._v("22 de Setembro de 2021")])
            ])
          ]),
          _c("div", { staticClass: "preco-item" }, [
            _c("span", [_vm._v("R$ 1000,00")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }